import type {
  NavigationMenuGroupChild,
  NavigationMenuGroupItem,
  NavigationMenuItem,
} from "@/components/header/navigationQuery.types";
import { ChevronRightIcon } from "@/components/icons/chevronRight.icon";

import {
  getFeaturedItems,
  toMobileMenuLink,
} from "./siteHeaderMobileMenuContent.utils";
import { SiteHeaderMobileMenuLink } from "./siteHeaderMobileMenuLink.component";

export const SiteHeaderMobileMenuRootOrFlatLinks = ({
  items,
  setSelectedMenu,
}: SiteHeaderMobileMenuRootOrFlatLinksProps) => (
  <ul className="flex flex-col">
    {items.map((item) => {
      if (item._type === "navigationGroup") {
        const hasChildren =
          Boolean("items" in item && item.items?.length) ||
          Boolean(getFeaturedItems(item as NavigationMenuGroupItem)?.length);
        if (!hasChildren) return null;
        return (
          <li key={item._key}>
            <button
              type="button"
              className="flex w-full items-center py-4 text-left font-bold tracking-wider capitalize"
              data-testid="site-header-mobile-menu-link"
              onClick={() => setSelectedMenu(item._key)}>
              <span className="flex-1">{item.label}</span>
              <span className="text-greyscale-strength" aria-hidden>
                <ChevronRightIcon width={16} height={16} />
              </span>
            </button>
          </li>
        );
      }

      const link = toMobileMenuLink(item);
      return link ? (
        <SiteHeaderMobileMenuLink key={item._key} item={link} />
      ) : null;
    })}
  </ul>
);

export type SiteHeaderMobileMenuRootOrFlatLinksProps = {
  items: Array<NavigationMenuItem | NavigationMenuGroupChild>;
  setSelectedMenu: (menu: string) => void;
};
